import * as yup from "yup";
import { PhoneDto } from "@client/common";
import { phoneSchema } from "@client/common";

export type PatientSearchResourcePhone = PhoneDto;

export interface PatientSearchResource {
  id: number;
  firstName: string;
  lastName: string;
  email: string | null;
  phone: PatientSearchResourcePhone;
  avatar: string | null;
}

export const patientSearchResourceSchema = yup.object().shape({
  id: yup.number().required(),
  firstName: yup.string().required(),
  lastName: yup.string().required(),
  email: yup.string().nullable().default(null),
  phone: phoneSchema.required(),
  avatar: yup.string().nullable().default(null),
});
